// extracted by mini-css-extract-plugin
export var image = "imageStrip-module--image--fb54f";
export var imageStrip = "imageStrip-module--image-strip--e5883";